import { ConditionDto } from '@/components/modules/Application/components/PaymentMethod/_shared/types/ConditionDto';
import { Conditions } from '@/components/modules/Application/components/PaymentMethod/_shared/types/Conditions';
import { ProviderName } from '@/types/ProviderName';

export abstract class AbstractConditionsGroup {
  protected bestCandidateConditions: Conditions | null = null;
  protected _allowedProviders: ProviderName[] | undefined;

  constructor(public readonly conditions: Conditions[]) {
    this.guardConditionsExist(conditions);
  }

  protected abstract getBestCandidateConditions(providers?: ProviderName[]): Conditions;

  public setAllowedProviders(providers: ProviderName[]): void {
    this._allowedProviders = providers;
  }

  public removeAllowedProviders(): void {
    this._allowedProviders = undefined;
  }

  private guardConditionsExist(conditions: Conditions[]): void {
    if (conditions.length === 0) {
      throw new Error('No conditions available');
    }
  }

  public getCandidateConditions(providers?: ProviderName[]): Conditions {
    //if (this.bestCandidateConditions) {
    //  return this.bestCandidateConditions;
    //}
    const bestCandidateConditions = this.getBestCandidateConditions(providers);
    this.bestCandidateConditions = bestCandidateConditions;
    return bestCandidateConditions;
  }

  public instalmentTotalAmount(providers?: ProviderName[]): ConditionDto {
    const bestCandidateConditions = this.getCandidateConditions(providers);

    const filteredConditions = providers
      ? this.conditions.filter((c) => c.providerName && providers.includes(c.providerName))
      : this.conditions;

    const hasMultiple =
      [...new Set(filteredConditions.map((condition) => condition.instalmentTotalAmount.value))].length > 1;

    return {
      value: bestCandidateConditions.instalmentTotalAmount.value,
      string: bestCandidateConditions.instalmentTotalAmount.string,
      hasMultiple,
    };
  }
}
